import React from 'react';
import VariableView from '../../../../../VariableView';

const ManageStep = ({ wizardType }) => <VariableView wizardType={wizardType} />;

export default ManageStep;
